import CalculatorStandardInput from '../../../calculatorInputs/CalculatorStandardInput';
import i18next from 'i18next';
import React from 'react';

const ComparisonValue = ({fieldName, showLabel, readOnly = false}) => {
  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}.${0}`}
      isRequired
      uxVariant="criteriaInput"
      variant="standard"
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.selectValues`
      )}
      validate={() => {
        return null;
      }}
      triggerOnContinue
      disabled={readOnly}
    />
  )
}

export default ComparisonValue;